import React from 'react';
import { Card as AntCard } from 'antd-v5';
import './style.less';
function Card(props) {
  const { style, bodyStyle, className, ...nativeProps } = props;

  return (
    <AntCard
      style={{ borderRadius: 4, boxShadow: 'none', ...style }}
      bodyStyle={{ padding: 16, ...bodyStyle }}
      {...nativeProps}
      className={`ui-card ${className}`}
    />
  );
}
export default Card;
